import React from "react";
import "./FacilityPerformance.less";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import { Grid, Button } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import FacilityPerformanceSectionData from "./FacilityPerformanceSectioWiseData";
import FacilityPerformanceGaugeChart from "./FacilityPerformanceGaugeChart";

class FacilityPerformance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyId: localStorage.getItem("selectedPropertyId"),
      getAllFacilitySection: [],
      sectionFilteredByPropertyId: [],
      openSectionPage: false
    };
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.state.datacenterList == undefined) {
      this.getDataCenterList();
    }
    this.getFacilityPerformanceSection();
  }

  /** Get report by section */
  GetReportBySection = () => {
    this.setState({ openSectionPage: true });
  };

  /** call on cancel */
  onCancel = () => {
    this.setState({ openSectionPage: false });
  };

  /** facility performance section */
  getFacilityPerformanceSection = () => {
    apiRequest({
      url: API_URL.facilityPerformance.getFacilityPerformanceSection
    }).then(({ data: List }) => {
      const sectionFilteredByPropertyId = List.filter(x => {
        if (x.PropertyId == this.state.selectedPropertyId) return x;
      });
      this.setState({
        getAllFacilitySection: List,
        sectionFilteredByPropertyId: sectionFilteredByPropertyId.sort((a, b) =>
          a.SectionSortOrder > b.SectionSortOrder ? 1 : -1
        )
      });
    });
  };

  /** Data center list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        this.setState({
          datacenterList: datacenterList
        });
      }
    );
  };

  /** Property selection */
  onPropertySelect = id => {
    localStorage.setItem("selectedPropertyId", id);
    const { getAllFacilitySection } = this.state;
    const sectionFilteredByPropertyId = getAllFacilitySection.filter(x => {
      if (x.PropertyId == id) return x;
    });
    this.setState({
      selectedPropertyId: id,
      sectionFilteredByPropertyId: sectionFilteredByPropertyId.sort((a, b) =>
        a.SectionSortOrder > b.SectionSortOrder ? 1 : -1
      )
    });
  };

  render() {
    const { sectionFilteredByPropertyId, openSectionPage } = this.state;

    return (
      <>
        {openSectionPage ? (
          <FacilityPerformanceSectionData onCancel={this.onCancel} />
        ) : (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item className={"reports-row-one"} xs={12} md={6}>
                    <Box className={" reports-dcList"} pl={1} pt={2} pb={2}>
                      <DatacenterList
                        dataSource={this.state.datacenterList}
                        onPropertySelect={this.onPropertySelect}
                        selectedPropertyId={this.state.selectedPropertyId}
                        classTitle={"dc-list-reports"}
                      />
                    </Box>
                  </Grid>
                  <div className={"row"}>
                    {(sectionFilteredByPropertyId || []).map((item, index) => (
                      <div
                        key={"ReportNavButtons" + index}
                        className={"col-xs-4 center-xs"}
                        // style={{ width: WidthStyle }}
                      >
                        <div>
                          <Button
                            className={
                              item.IsEnable == true
                                ? "runReport-button"
                                : "disable-runReport-button"
                            }
                            variant={"contained"}
                            //  disabled={!item.IsEnable}
                            onClick={() => {
                              item.SectionDisplayName == "Generator" &&
                                this.GetReportBySection(item);
                            }}
                          >
                            {item.SectionDisplayName}{" "}
                          </Button>
                        </div>
                        {item.SectionDisplayName == "ATS" && (
                          <div>
                            <Button className={"gauge-button"}>
                              <FacilityPerformanceGaugeChart displayText={"DATA HALL 100"} />
                            </Button>
                            <div style={{ textAlign: "center" }}>
                              {"DATA HALL 100 R/H\r"}
                            </div>
                          </div>
                        )}
                        {item.SectionDisplayName == "Data Hall TEMP/RH" && (
                          <div>
                            <Button className={"gauge-button"}>
                              <FacilityPerformanceGaugeChart displayText={"DATA HALL 100 PUE"} />
                            </Button>
                            <div style={{ textAlign: "center" }}>
                              {"DATA HALL 100 PUE\r"}
                            </div>
                          </div>
                        )}
                        {item.SectionDisplayName == "MAU" && (
                          <div>
                            <Button className={"gauge-button"}>
                              <FacilityPerformanceGaugeChart displayText={"DATA HALL 100 TEMPERATURE"} />
                            </Button>
                            <div style={{ textAlign: "center" }}>
                              {"DATA HALL 100 TEMPERATURE\r"}
                            </div>
                          </div>
                        )}{" "}
                      </div>
                    ))}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </>
    );
  }
}

export default FacilityPerformance;
